import React, { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { PageHeader } from "../../layout/AppLayout";
import { ErpTable } from "../../components/erp";
import { errorText } from "../../api/client";
import { ApprovalRow, inwardApprovalApi } from "./api";

/** Port of v3/ColdStore/admin-inward-approval.php - approves pending `CsStockData` rows
 * (StockStatus 0 -> 1). NOTE: real QA data shows zero StockStatus=0 rows exist (no current INSERT
 * path sets it - see MIGRATION.md AMBIGUOUS_KT); default view below is the source-faithful
 * "Pending" filter and will show empty unless a row is manually forced to StockStatus=0. */
export default function InwardApprovalPage() {
  const [status, setStatus] = useState("0");
  const [selected, setSelected] = useState<number[]>([]);
  const qc = useQueryClient();
  const list = useQuery({ queryKey: ["coldstore", "inward-approval", status], queryFn: () => inwardApprovalApi.list({ StockStatus: status }) });

  const toggle = (id: number) => setSelected((s) => s.includes(id) ? s.filter((x) => x !== id) : [...s, id]);
  const approve = async () => {
    if (!selected.length) return;
    await inwardApprovalApi.approve(selected.join(","));
    setSelected([]);
    qc.invalidateQueries({ queryKey: ["coldstore", "inward-approval", status] });
  };

  return (
    <>
      <PageHeader title="Admin Inward Approval" location="ColdStore" />
      <div className="card mb-3"><div className="card-body">
        <div className="row">
          <div className="col-md-3 mb-3"><label className="form-label">Status</label>
            <select className="form-select" value={status} onChange={(e) => { setStatus(e.target.value); setSelected([]); }} data-testid="approval-status-filter">
              <option value="0">Pending Approval</option><option value="1">Approved</option>
            </select></div>
        </div>
      </div></div>
      <div className="card"><div className="card-body">
        <div className="d-flex justify-content-between mb-3"><h6>Stock ({list.data?.TotalCount ?? 0})</h6>
          {status === "0" && <button className="btn btn-sm btn-success" data-testid="approval-approve-selected" disabled={!selected.length} onClick={approve}>Approve Selected ({selected.length})</button>}
        </div>
        <ErpTable<ApprovalRow> testId="approval-table" loading={list.isLoading} error={list.isError ? errorText(list.error) : null}
          rows={list.data?.Data || []} columns={[
            ...(status === "0" ? [{ key: "Select", title: "", render: (r: ApprovalRow) => (
              <input type="checkbox" checked={selected.includes(r.StockID)} onChange={() => toggle(r.StockID)} data-testid={`approval-check-${r.StockID}`} />
            ) }] : []),
            { key: "StockID", title: "Stock ID" }, { key: "VarietyName", title: "Variety" }, { key: "Grade", title: "Grade" },
            { key: "AvalMcs", title: "Mcs" }, { key: "LooseBags", title: "Loose" }, { key: "PackingStyle", title: "Packing Style" },
            { key: "Location", title: "Location" }, { key: "StoreName", title: "Store" },
          ]} />
      </div></div>
    </>
  );
}
